import { randomGeneratedIcons } from '../constants/symbolsNames';

// RU: номер иконки-наполнителя барабана (прокрутка, поля над и под окном). Wild (9) в ленте
//     нет — поэтому его нет и в наполнителе, на любом барабане.
//
//     Это вся рабочая логика прежней версии: N-й вызов брал N-ю иконку ленты и оставлял её,
//     только если это '1', иначе — случайную иконку ленты. '1' в ленте одна, поэтому
//     детерминирован ровно один вызов, все остальные случайны. Фильтры по барабанам не
//     срабатывали никогда (wild в ленте нет, а условие «не 1-й ИЛИ не 3-й» всегда истинно) и
//     сняты вместе с номером барабана в аргументах.
const PINNED_ICON = '1';
const PINNED_DRAW = randomGeneratedIcons.indexOf(PINNED_ICON);

export class SpinIconNumberProvider {
  drawCount = 0;

  getNext() {
    const icon =
      this.drawCount === PINNED_DRAW
        ? PINNED_ICON
        : randomGeneratedIcons[Math.floor(Math.random() * randomGeneratedIcons.length)];
    this.drawCount += 1;
    return icon;
  }
}
